import { fetch as fetchApi, isString } from "./api";

export async function fetch(id: string | null | undefined, params?: {}): Promise<any> {
  return fetchApi({
    nestedResourcePath: ["offlinePaymentTypeGroup"],
    id,
    params
  })
    .then(response => {
      return isString(response.data) ? JSON.parse(response.data) : response.data;
    })
    .then(data => data);
}
